import axios from 'axios'

axios.defaults.headers.common['x-service'] = 'MyQlocx'

axios.interceptors.response.use(
  (response) =>
    // console.log('response', response)
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    response,
  (error) => {
    // console.log(error.response)
    if (window.Intercom) window.Intercom('trackEvent', 'error', { status: error.status, statusText: error.statusText, message: error.response?.data?.message })
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    const err = new Error(error.response?.data?.message)

    err.response = error.response

    return Promise.reject(err)
  }
)

const TEST = false

let hostname = TEST ? 'http://localhost:3001/api' : 'https://my.qlocx.com/api'
const consumerhostname = TEST ? 'http://localhost:7777' : 'https://consumer.qlocx.com'
let storagehost = TEST ? 'http://localhost:4000/api/graphql?' : 'https://storagebackend.o6jo571ucj14o.eu-west-1.cs.amazonlightsail.com/api/graphql?'

console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
  // window.BASE_NAME = '/myqlocx/'
  window.MYQLOCX_API = 'http://localhost:3001/api'
  window.STORAGE_API = 'http://localhost:3002/api/graphql?'
}

if (window.location.href.includes('ngrok.io')) {
  console.log(window.location)
  window.MYQLOCX_API = 'https://f38aef31.ngrok.io/api'
}

storagehost = window.location.href.includes('staging') ? 'https://staging.qlocx.com/storage/api/graphql?' : storagehost

hostname = window.location.href.includes('staging') ? 'https://staging.qlocx.com/myqlocx/api' : hostname

window.MYQLOCX_API = hostname
window.STORAGE_API = storagehost

export default {
  hostname,
  consumerhostname,
  storagehost,
}
